import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';

export const CloudAccountStatusEntity: IEntity<any> = {
  url: '/rest/product-settings-cloud/products/cloud/{serviceId}/accountStatus',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'psc:getaccountstatus',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

export const CloudAccountActivationEntity: IEntity<any> = {
  url: '/rest/product-settings-cloud/products/cloud/{serviceId}/accountActivation',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'psc:accountactivation',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: SessionStorageStrategy.ID,
};
